<template>
  <div id="empresa">
    <div class="titulo">
      <div class="background-preto">
        <h1>Quem somos</h1>
        <p>
          A FlexFilm é uma empresa especializada em películas de controle solar, segurança, filmes decorativos e envelopamento, adesivos em geral. Atua nesse mercado exigente de revestimentos a mais de 10 anos e oferece a seus clientes o que existe de mais moderno em soluções para excesso de luminosidade, calor, segurança ou decoração.
        </p>
        <p></p>
        <p></p>
        <p></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
#empresa {
  margin-top: 130px;
  width: 100%;
}

#empresa h1 {
  padding-top: 50px;
  margin-bottom: 30px;
  font-size: 54px;
  color: white;
  font-weight: 900;
  text-align: center;
}

#empresa .titulo p {
  color: white;
  max-width: 710px;
  text-align: center;
  margin: 0 auto;
  padding: 10px;
}

#empresa .titulo {
  background-image: url("../assets/background.png");
  background-size: cover;
  background-position: center center;
  width: 100%;
}

.background-preto {
  background: rgba(0, 0, 0, 0.493);
  height: 100%;
}

.historia {

  max-width: 900px;
  margin: 50px auto;
  display: grid;
  grid-template-areas:
    "paragrafo1 imagem1"
    "paragrafo2 imagem1"
    "imagem2 paragrafo3"
    "imagem2 paragrafo4"
    "imagem3 imagem4"
    "paragrafo5 imagem4"
    "paragrafo6 paragrafo6";
}

.historia .imagem img {
  max-width: 400px;
}

.historia .imagem p {
  color: #3333339f;
  text-align: center;
}

.historia p {
  color: #333333;
  max-width: 400px;
}

.paragrafo1 {
  grid-area: paragrafo1;
}

.paragrafo2 {
  grid-area: paragrafo2;
}

.paragrafo3 {
  grid-area: paragrafo3;
}

.paragrafo4 {
  grid-area: paragrafo4;
}

.paragrafo5 {
  grid-area: paragrafo5;
}

.paragrafo6 {
  grid-area: paragrafo6;
}

.imagem1 {
  grid-area: imagem1;
}

.imagem2 {
  grid-area: imagem2;
}

.imagem3 {
  grid-area: imagem3;
}

.imagem4 {
  grid-area: imagem4;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .historia {
    margin: 20px;
    grid-template-areas:
      "paragrafo1"
      "imagem1"
      "paragrafo2"
      "imagem2"
      "paragrafo3"
      "paragrafo4"
      "imagem3"
      "paragrafo5"
      "imagem4"
      "paragrafo6";
  }
  .historia .imagem img {
    max-width: 100%;
  }
}
</style>